// extracted by mini-css-extract-plugin
export default {"CloseButton":"CloseButton_CloseButton__HFTfw","CloseButton__Icon":"CloseButton_CloseButton__Icon__ncLY1"};